import { doDefaultFetch } from '@nhl/fetch-helpers';
import { hockeyFormatter } from '@nhl/formatter-utilities';

const fetchSeasonIds = args => {
    return doDefaultFetch(
        `/site/api/season` +
        `?sort=id` +
        `&dir=DESC`,
        args
    );
};

const generateSeasonSelectOptions = seasons => {
    return seasons.map(season => {
        season.value = season.id;
        season.label = hockeyFormatter.singleSeasonFormatter(season.id);

        return season;
    });
};


const findSeasonById = (seasons, id) => seasons.find(season => season.id === id);

export default {
    fetchSeasonIds,
    generateSeasonSelectOptions,
    findSeasonById,

};
